import { Button, Container, Paragraph, SizableText, XStack, YStack } from '@my/ui'
import { ChevronDown, ChevronUp } from '@tamagui/lucide-icons'
import { KeyboardAwareScrollView, MainLayout, Meta, H3 } from 'app/components'
import { useState } from 'react'
import { WriteForUsForm } from './containers'
import { AuthUser } from 'app/provider/auth'
import { LoggedOutWriteForUsForm } from './components'

export interface WriteForUsScreenProps {
  user: AuthUser | null
}

export const WriteForUsScreen = (props: WriteForUsScreenProps) => {
  const [showMore, setShowMore] = useState(false)

  return (
    <MainLayout>
      <Meta title="Write for us" />
      <Container spaceTop spaceBottom>
        <Container size="sm" bc="$white" gutter>
          <KeyboardAwareScrollView>
            <YStack mt="$4" gap="$2">
              <H3 fow="600">Write For Us</H3>
              <Paragraph color="$overlay11">We'd LOVE to hear from you!</Paragraph>
            </YStack>
            <YStack gap="$6" mt="$6">
              <Paragraph color="$overlay11" fow="500">
                Are you an aspiring writer or journalist? Have an interesting story about Uni life
                you want to pitch? Or are you passionate about meme’s and want to share your
                favourites? We’d love to hear from you!
              </Paragraph>
              <Paragraph color="$overlay11" fow="500">
                Here at Student Saviour we are always on the lookout for talented students,
                graduates, or freelance writers. To enquire, get in touch with us explaining why you
                think you would be a perfect addition to the Student Saviour team.
              </Paragraph>
              {showMore && (
                <Paragraph color="$overlay11" fow="500">
                  Don’t have any experience yet? Don’t worry at all. We’re super excited to work
                  with fresh talent, with or without experience. If you have done anything similar
                  before, let us know about any relevant experience or any examples of previous work
                  you might have.
                </Paragraph>
              )}
              <Button plain onPress={() => setShowMore(!showMore)}>
                <XStack gap="$2" alignItems="center">
                  {showMore ? (
                    <>
                      <SizableText>Show Less</SizableText>
                      <ChevronUp size={22} />
                    </>
                  ) : (
                    <>
                      <SizableText>Show More</SizableText>
                      <ChevronDown size={22} />
                    </>
                  )}
                </XStack>
              </Button>
            </YStack>

            <YStack my="$6">
              {props.user ? <WriteForUsForm user={props.user} /> : <LoggedOutWriteForUsForm />}
            </YStack>
          </KeyboardAwareScrollView>
        </Container>
      </Container>
    </MainLayout>
  )
}
